(() => {
  const BUTTON_SELECTOR = '[data-spp-sale-add]';

  const getRootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const decorateButtons = (scope) => {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      button.classList.add('spp-atc-motion', 'spp-atc-motion--primary');
      button.setAttribute('data-spp-atc-motion', 'primary');
    });
  };

  const updateHeaderCount = (count) => {
    const selectors = [
      '.cart-count-bubble span:first-child',
      '[data-cart-count]',
      '.spp-header__cart-badge',
      '.ch-cart-count'
    ];

    document.querySelectorAll(selectors.join(',')).forEach((node) => {
      node.textContent = String(count);
      if (node.hasAttribute('data-cart-count')) node.setAttribute('data-cart-count', String(count));
    });
  };

  const refreshCartCount = async () => {
    try {
      const response = await fetch(`${getRootPath()}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      updateHeaderCount(cart.item_count || 0);
    } catch (error) {
      console.warn('[SPP Sale] Cart count refresh skipped:', error);
    }
  };

  const refreshCartBubble = (data) => {
    const bubble = document.getElementById('cart-icon-bubble');
    const html = data && data.sections && data.sections['cart-icon-bubble'];
    if (!bubble || !html) return;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = html.trim();
    const replacement = wrapper.querySelector('#cart-icon-bubble');
    if (replacement) bubble.replaceWith(replacement);
  };

  const renderAndOpenDrawer = (data) => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
      window.setTimeout(() => {
        if (typeof drawer.open === 'function') drawer.open();
      }, 70);
      return;
    }
    refreshCartBubble(data);
  };

  const showMotionError = (button) => {
    button.classList.remove('spp-atc-motion--running', 'spp-atc-motion--added');
    button.classList.add('spp-atc-motion--error');
    window.setTimeout(() => button.classList.remove('spp-atc-motion--error'), 380);
  };

  const addVariant = async (button) => {
    if (!button || button.dataset.sppSaleBusy === 'true') return;

    const variantId = Number(button.dataset.variantId || 0);
    if (!variantId) {
      showMotionError(button);
      return;
    }

    button.dataset.sppSaleBusy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${getRootPath()}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add item');
      }

      renderAndOpenDrawer(data);
      refreshCartBubble(data);
      await refreshCartCount();

      /* These are the same success signals used by the exact global ATC motion. */
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));

      window.setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.dataset.sppSaleBusy = 'false';
      }, 2850);
    } catch (error) {
      console.error('[SPP Sale] Add to cart failed:', error);
      showMotionError(button);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.dataset.sppSaleBusy = 'false';
    }
  };

  const initSale = (root) => {
    if (!root) return;

    decorateButtons(root);

    /* Remove the duplicate reassurance bar because the footer already contains it. */
    const trustBar = root.querySelector('.spp-sale-v2__trust-section');
    if (trustBar) trustBar.remove();

    if (root.dataset.sppSaleExactAtc === 'true') return;
    root.dataset.sppSaleExactAtc = 'true';

    /*
      The exact global ATC animation listens on document capture first.
      This root capture listener then takes over the Ajax add and stops the older
      Sale-page bubble handler, so the animation and cart action stay in sync.
    */
    root.addEventListener('click', (event) => {
      const button = event.target.closest && event.target.closest(BUTTON_SELECTOR);
      if (!button || !root.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();
      addVariant(button);
    }, true);
  };

  const initAll = (scope = document) => {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches('[data-spp-sale-v2]')) initSale(scope);
    scope.querySelectorAll('[data-spp-sale-v2]').forEach(initSale);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    window.setTimeout(() => initAll(event.target), 20);
  });
})();
